
export const HTTP_LOCAL_HOST_3000 = "http://localhost:3000";
export const HTTPS_LOCAL_HOST_3000 = "https://localhost:3000";
